import React, { useEffect } from 'react'
import { DialogContent, DialogTitle } from '@common/material'
import { ModalDialogContainer } from '@common/modal'
import { MFAForm } from './MFAForm'
import { useWebAuthContext } from 'webapp/providers/authentication/WebAuthProvider'
import { useModal } from '@common/GlobalModal'
import { localizedStrings } from '@core/strings'

interface MFAModalProps {
  open: boolean
}

export const MFAModal: React.FC<MFAModalProps> = ({ open }) => {
  const { setMFAToken, refreshAuthState } = useWebAuthContext()
  const { hideModal } = useModal()

  const handleOnSuccess = async (token: string) => {
    // Store the MFA token
    setMFAToken(token)

    // Refresh auth state to update the UI
    await refreshAuthState()

    // Close the modal
    hideModal()
  }

  const handleOnFocus = async () => {
    if (open) {
      await refreshAuthState()
    }
  }

  useEffect(() => {
    window.addEventListener('focus', handleOnFocus)

    return () => {
      window.removeEventListener('focus', handleOnFocus)
    }
  }, [open])

  const handleClose = () => {
    hideModal()
  }

  if (!open) {
    return null
  }

  return (
    <ModalDialogContainer
      data-test='mfa-modal'
      onClose={handleClose}
      PaperProps={{ sx: { maxWidth: 480, width: '90%' } }}
    >
      <DialogTitle
        variant='h5'
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        sx={{ pr: 1, fontSize: 20 }}
      >
        {localizedStrings.mfaVerificationRequired}
      </DialogTitle>

      <DialogContent>
        <MFAForm onSuccess={handleOnSuccess} />
      </DialogContent>
    </ModalDialogContainer>
  )
}
